import Badge from './badge';
export * from './badge';
export default Badge;